 <div class="row" style="padding-top: 5px;">
   <div class="col-lg-12">

     <app-table-title [fontSize]="'24px'"
                      [title]="ownershipTitle + ' ' + ('INFORMATION' | dictionary)"></app-table-title>
     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__body">
         <div class="m-section" style="margin-bottom: 0;">
           <div class="m-section__content">
             <div class="flex-row">
               <h5 class="font-size-18 margin-10-0">
                 {{userInfoConfigurationUserTypeWise.myUserInfo.headerText}}
                 :&nbsp;<span>{{userProfileEntity.UserNum}}</span></h5>
               <span class="activation-status">
                 <div class="circle"
                      [style.background]="userProfileEntity.DeactivatedDate? 'darkred' : (userProfileEntity.ActivatedDate? 'darkgreen' : 'grey' )"></div>
     <span
       *ngIf="userProfileEntity.ActivatedDate && !userProfileEntity.DeactivatedDate">Active as of: {{userProfileEntity.ActivatedDate | date : "MM/dd/yyyy"}}</span>
               <span
                 *ngIf="userProfileEntity.DeactivatedDate">Inactive as of: {{userProfileEntity.DeactivatedDate | date : "MM/dd/yyyy"}}</span>
               <span *ngIf="!userProfileEntity.DeactivatedDate && !userProfileEntity.ActivatedDate">Not Activated</span>


 </span>

             </div>

             <div class="table-responsive">
               <table class="table">
                 <tbody>
                 <!-- <tr>
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">{{'USERNAME' | dictionary}}:</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-black">{{userId}}</label>
                   </td>
                   <td colspan="2"></td>
                 </tr> -->
                 <tr>
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">{{'EMAIL_ADDRESS' | dictionary}}:</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-black">{{userProfileEntity.EmailAddress}}</label>
                   </td>
                   <td colspan="2"></td>
                 </tr>

                 </tbody>
               </table>

               <div class="actions-wrapper">
                 <!-- <button (click)="changePassword()" class="button-1 mr-10"
                         *ngIf="userInfoConfigurationUserTypeWise.changePasswordDisp && isCurrentUserProfile"
                 >{{'CHANGE_PASSWORD' | dictionary}}
                 </button> -->
                 <button (click)="updateProfile()" class="button-1"
                         *ngIf="!userInfoConfigurationUserTypeWise.editProfile.emailAddressDisable && userProfileEntity.ActivatedDate">{{'EDIT_PROFILE' | dictionary}}
                 </button>
                 <button (click)="changeActivationStatus('activate')" class="button-1 ml-2"
                         *ngIf=" !isCurrentUserProfile  && originalUser_userType === 'U' && !userProfileEntity.ActivatedDate && (userType === 'B' || userType === 'T')">{{'ACTIVATE' | dictionary}}
                 </button>
                 <button (click)="changeActivationStatus('deactivate')" class="button-1 ml-2"
                         *ngIf=" !isCurrentUserProfile  && originalUser_userType === 'U' && userProfileEntity.ActivatedDate && !userProfileEntity.DeactivatedDate">{{'DEACTIVATE' | dictionary}}
                 </button>
                 <button (click)="changeActivationStatus('reactivate')" class="button-1 ml-2"
                         *ngIf=" !isCurrentUserProfile  && originalUser_userType === 'U' && userProfileEntity.ActivatedDate && userProfileEntity.DeactivatedDate">{{'REACTIVATE' | dictionary}}
                 </button>

               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>

 <div class="row" style="padding-top: 5px;">
   <div class="col-lg-12">
     <app-table-title [fontSize]="'24px'"
                      [title]="accountOwnershipTitle + ' ' + ('ACCOUNT_INFO' | dictionary)"></app-table-title>
     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__body">
         <div class="m-section" style="margin-bottom: 0;">
           <div class="m-section__content">
             <h5 class="margin-10-0 font-size-18">
               <!-- {{userInfoConfigurationUserTypeWise.myAccountInfo.headerText}}
               :&nbsp;<span>{{userProfileEntity.TaxId}}</span>  -->
               &nbsp;
             </h5>
             <div class="table-responsive">
               <table class="table">
                 <tbody>
                 <tr>
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">{{'NAME' | dictionary}}:</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-black">{{userProfileEntity.Username}}</label>
                   </td>
                   <td></td>
                   <td></td>
                 </tr>
                 <tr *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.currentAddressDisp">
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">
                       {{'CURRENT_ADDRESS' | dictionary}}:
                     </label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.CurrAddressLine1}}</label>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.CurrAddressLine2}}</label>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.CityStateZip}}
                     </label>
                   </td>


                   <!-- <td>
                     <label class="home-announcements text-color-deep-heading padding-from"
                            *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.addValidityDisp">{{'FROM' | dictionary}}
                       :</label>
                     <label *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.addValidityDisp"
                            class="home-announcements ">
                       <FormatLabel
                         [Text]="userProfileEntity.CurrAddressBegMonthDay"
                         class="FieldContent text-color-deep-heading" MaskPattern="00/00"></FormatLabel>
                     </label>

                     <label class="home-announcements text-color-deep-heading padding-to"
                            *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.addValidityDisp">{{'TO' | dictionary}}
                       :</label>
                     <label *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.addValidityDisp"
                            class="home-announcements ">
                       <FormatLabel
                         [Text]="userProfileEntity.CurrAddressEndMonthDay"
                         class="FieldContent text-color-deep-heading" MaskPattern="00/00"></FormatLabel>
                     </label>
                   </td>  -->
                   <td></td>

                 </tr>

                 <tr *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.currentAddressDisp">
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">{{'PHONE'| dictionary}}
                       :</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-black">
                       <FormatLabel #txtEffectiveFrom [Text]="userProfileEntity.Phone"
                                    class="FieldContent" MaskPattern="(999) 000-0000"></FormatLabel>
                     </label>
                   </td>
                   <td>
                     <label class="home-announcements text-color-deep-heading"></label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-deep-heading"></label>
                   </td>
                 </tr>

                 <tr *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.legalAddressDisp">
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">
                       {{'LEGAL_ADDRESS' | dictionary}}:
                     </label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.LegalAddressLine1}}</label>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.LegalAddressLine2}}</label>
                     <label style="padding-left: 25px;display: block;text-align: left;"
                            class="home-announcements text-color-black">{{userProfileEntity.LegalCityStateZip}}
                     </label>
                   </td>
                   <!-- <td>
                     <label class="home-announcements text-color-deep-heading">{{'FROM' | dictionary}}:</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-deep-heading">
                       <FormatLabel #txtEffectiveFrom
                                    [Text]="userProfileEntity.LegalAddressBegMonthDay"
                                    class="FieldContent" MaskPattern="00/00"></FormatLabel>
                       <label>{{'TO' | dictionary}}</label>
                       <FormatLabel #txtEffectiveTo
                                    [Text]="userProfileEntity.LegalAddressEndMonthDay"
                                    class="FieldContent" MaskPattern="00/00"></FormatLabel>
                     </label>
                   </td>  -->
                 </tr>

                 <tr *ngIf="userInfoConfigurationUserTypeWise.myAccountInfo.legalAddressDisp">
                   <td style="width: 100px;"></td>
                   <td style="width: 125px;text-align: right;">
                     <label class="home-announcements text-color-deep-heading">{{'PHONE'| dictionary}}:</label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-deep-heading">
                       <FormatLabel #txtEffectiveFrom [Text]="userProfileEntity.LegalPhone"
                                    class="FieldContent" MaskPattern="(999) 000-0000"></FormatLabel>
                     </label>
                   </td>
                   <td>
                     <label class="home-announcements text-color-deep-heading"></label>
                   </td>
                   <td>
                     <label style="padding-left: 25px;"
                            class="home-announcements text-color-deep-heading"></label>
                   </td>
                 </tr>
                 </tbody>
               </table>
               <div class="actions-wrapper">
                 <button (click)="updateAddress()" *ngIf="userInfoConfigurationUserTypeWise.requestAddressChangeDisp"

                         class="button-1">{{'REQUEST_ADDRESS_CHANGE' | dictionary}}
                 </button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>

 <div class="row" style="padding-top: 5px;" *ngIf="userInfoConfigurationUserTypeWise.associateAccountDisp">
   <div class="col-lg-12">
     <app-table-title [fontSize]="'24px'" [title]="'LINK_ACCOUNTS' | dictionary"></app-table-title>
     <div class="subtitle-line-wrapper"><span>This section will allow you to link other accounts to your account so all accounts are viewable under a single log in.<br>You must know both the
       {{getUserTypeTitle(this.authService.UserType)}} ID and PIN(s) of the accounts you wish to link.</span>
       <button class="button-1" (click)="showLinkAccountPopup()">{{'LINK_ACCOUNT' | dictionary}}</button>
     </div>
     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__body" style="min-height: 100px;">
         <div class="m-section" style="margin-bottom: 0;">
           <div class="m-section__content">
             <div class="table-responsive" *ngIf="linkAccounts?.length > 0">
               <table class="table">
                 <tbody>

                 <tr>
                   <th class="text-color-deep-heading">{{'ACCOUNT_NUM' | dictionary}}</th>
                   <th class="text-color-deep-heading">{{'ACCOUNT_NAME' | dictionary}}</th>
                   <th class="text-color-deep-heading">{{'ACCOUNT_TYPE' | dictionary}}</th>
                   <th class="text-color-deep-heading">{{'ACCOUNT_EMAIL' | dictionary}}</th>
                   <th class="text-color-deep-heading">{{'REMOVE_ACCOUNT' | dictionary}}</th>
                 </tr>

                 <tr *ngFor="let item of linkAccounts" class="linked-accounts-body">

                   <td class="text-color-black">{{item.RecordNum}}</td>
                   <td class="text-color-black">{{item.Name}}</td>
                   <td class="text-color-black">{{item.RecordType}}</td>
                   <td class="text-color-black">{{item.EmailAddress}}</td>
                   <td class="text-color-black cursor-pointer text-underline link-3"
                       (click)="askConfirmation(item)">{{'DELETE' | dictionary}}</td>

                   <td>
                   </td>
                 </tr>
                 </tbody>
               </table>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>

 <!-- <div class="row" style="padding-top: 5px;" *ngIf="listOtherLogins">  -->
 <div class="row" style="padding-top: 5px; display: none;">
   <div class="col-lg-12">
     <app-table-title [fontSize]="'24px'" [title]="'OTHER_LOGINS' | dictionary"></app-table-title>
     <div class="subtitle-line-wrapper"><span>From this section you have the ability to add new logins across this account.<br>
     The following have been granted across the account.</span>
       <button class="button-1" (click)="showAddNewLoginPopup()">{{'ADD_NEW_LOGIN' | dictionary}}</button>
     </div>
         <div class="m-portlet m-portlet--unair">
           <div class="m-portlet__body" style="min-height: 100px;">
             <div class="m-section" style="margin-bottom: 0;">
               <div class="m-section__content">
                 <div class="table-responsive" *ngIf="listOtherLogins?.length > 0">
                   <table class="table">
                     <tbody>

                     <tr>
                       <th class="text-color-deep-heading">{{'ACCOUNT_NUM' | dictionary}}</th>
                       <th class="text-color-deep-heading">{{'ACCOUNT_NAME' | dictionary}}</th>
                       <th class="text-color-deep-heading">{{'REMOVE_ACCOUNT' | dictionary}}</th>
                     </tr>

                     <tr *ngFor="let item of listOtherLogins" class="linked-accounts-body">

                       <td class="text-color-black">{{item.RecordNum}}</td>
                       <td class="text-color-black">{{item.Name}}</td>
                       <td class="text-color-black cursor-pointer text-underline link-3"
                           (click)="askConfirmationOfAccountAccessRemoval(item)">{{'DELETE' | dictionary}}</td>
                       <td>
                       </td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
             </div>
           </div>
         </div>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="display = false">
 </app-pop-up-dialog>

 <app-pop-up-confirmation [cancelButton]="'CANCEL'" [confirmButton]="'CONTINUE'"
                          [Message]="alertMessage" [Display]="displayConfirmationPopup"
                          (DisplayBack)="displayConfirmationPopup = false; onConfirm($event)"></app-pop-up-confirmation>
